<template>
  <v-card>
    <v-card-text>
      <form data-vv-scope="occpnForm">
        <v-container fluid grid-list-sm>
          <v-layout row wrap>
            <v-flex xs12 md4 lg4 v-if="riskSurveyMode === 'Query'">
              <v-subheader class="queryLabel">{{ labels.occpnCls }}</v-subheader>
              <div class="queryValue" v-for="item in filterOccpnClsList" :key="item.label">{{ item.label }}</div>
            </v-flex>
            <v-flex xs12 md4 lg4 v-else>
              <v-autocomplete
                :items="occpnClsList"
                v-model="occpnForm.occpnCls"
                :label="labels.occpnCls"
                item-text="label"
                item-value="value"
                data-vv-name="occpnForm.occpnCls"
                :data-vv-as="labels.occpnCls"
                :error-messages="errors.collect('occpnForm.occpnCls')"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs12 md4 lg4 v-if="riskSurveyMode === 'Query'">
              <v-subheader class="queryLabel">{{ labels.goodsType }}</v-subheader>
              <div class="queryValue">{{ occpnQueryForm.goodsType }}</div>
            </v-flex>
            <v-flex xs12 md4 lg4 v-else>
              <v-text-field
                :label="labels.goodsType"
                v-model="occpnForm.goodsType"
                :error-messages="errors.collect('occpnForm.goodsType')"
                data-vv-name="occpnForm.goodsType"
                :data-vv-as="labels.goodsType"
                append-icon="mdi-magnify"
                @click:append="getHelpList('goodsType')"
                readonly
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md4 lg4 v-if="riskSurveyMode === 'Query'">
              <v-subheader class="queryLabel">{{ labels.packType }}</v-subheader>
              <div class="queryValue">{{ occpnQueryForm.packType }}</div>
            </v-flex>
            <v-flex xs12 md4 lg4 v-else>
              <v-text-field
                :label="labels.packType"
                v-model="occpnForm.packType"
                :error-messages="errors.collect('occpnForm.packType')"
                data-vv-name="occpnForm.packType"
                :data-vv-as="labels.packType"
                append-icon="mdi-magnify"
                @click:append="getHelpList('packType')"
                readonly
              ></v-text-field>
            </v-flex>
            <v-flex xs12 v-if="riskSurveyMode === 'Query'">
              <v-subheader class="queryLabel">{{ labels.goodsFlam }}</v-subheader>
              <div class="queryValue">{{ occpnForm.goodsFlam }}</div>
            </v-flex>
            <v-flex xs12 v-else>
              <v-text-field
                :label="labels.goodsFlam"
                v-model="occpnForm.goodsFlam"
                :error-messages="errors.collect('occpnForm.goodsFlam')"
                data-vv-name="occpnForm.goodsFlam"
                :data-vv-as="labels.goodsFlam"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 v-if="riskSurveyMode === 'Query'">
              <v-subheader class="queryLabel">{{ labels.storeArr }}</v-subheader>
              <div class="queryValue">{{ occpnForm.storeArr }}</div>
            </v-flex>
            <v-flex xs12 v-else>
              <v-text-field
                :label="labels.storeArr"
                v-model="occpnForm.storeArr"
                :error-messages="errors.collect('occpnForm.storeArr')"
                data-vv-name="occpnForm.storeArr"
                :data-vv-as="labels.storeArr"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 v-if="riskSurveyMode === 'Query'">
              <v-subheader class="queryLabel">{{ labels.stacksHgt }}</v-subheader>
              <div class="queryValue">{{ occpnForm.stacksHgt }}</div>
            </v-flex>
            <v-flex xs12 v-else>
              <v-text-field
                :label="labels.stacksHgt"
                v-model="occpnForm.stacksHgt"
                :error-messages="errors.collect('occpnForm.stacksHgt')"
                data-vv-name="occpnForm.stacksHgt"
                :data-vv-as="labels.stacksHgt"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md4 lg4 v-if="riskSurveyMode === 'Query'">
              <v-subheader class="queryLabel">{{ labels.whsType }}</v-subheader>
              <div class="queryValue" v-for="item in filteWhsTyppeList" :key="item.label">{{ item.label }}</div>
            </v-flex>
            <v-flex xs12 md4 lg4 v-else>
              <v-autocomplete
                :items="whsTypeList"
                v-model="occpnForm.whsType"
                :label="labels.whsType"
                item-text="label"
                item-value="value"
                data-vv-name="occpnForm.whsType"
                :data-vv-as="labels.whsType"
                :error-messages="errors.collect('occpnForm.whsType')"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs12 md4 lg4>
              <v-checkbox
                color="primary"
                :label="labels.othTent"
                v-model="occpnForm.othTent"
                :disabled="riskSurveyMode === 'Query' ? true : false"
              ></v-checkbox>
            </v-flex>
            <v-flex xs12 md4 lg4>
              <v-checkbox
                color="primary"
                :label="labels.part"
                v-model="occpnForm.part"
                :disabled="riskSurveyMode === 'Query' ? true : false"
              ></v-checkbox>
            </v-flex>
            <v-flex xs12 md4 lg4 v-if="riskSurveyMode === 'Query'">
              <v-subheader class="queryLabel">{{ labels.partType }}</v-subheader>
              <div class="queryValue" v-for="item in filterPartTypeList" :key="item.label">{{ item.label }}</div>
            </v-flex>
            <v-flex xs12 md4 lg4 v-else>
              <v-autocomplete
                :items="partTypeList"
                v-model="occpnForm.partType"
                :label="labels.partType"
                item-text="label"
                item-value="value"
                data-vv-name="occpnForm.partType"
                :data-vv-as="labels.partType"
                :error-messages="errors.collect('occpnForm.partType')"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs12 md3 lg3 v-if="riskSurveyMode === 'Query'">
              <v-subheader class="queryLabel">{{ labels.othTentGoods }}</v-subheader>
              <div class="queryValue">{{ occpnQueryForm.othTentGoods }}</div>
            </v-flex>
            <v-flex xs12 md3 lg3 v-else>
              <v-text-field
                :label="labels.othTentGoods"
                v-model="occpnForm.othTentGoods"
                :error-messages="errors.collect('occpnForm.othTentGoods')"
                data-vv-name="occpnForm.othTentGoods"
                :data-vv-as="labels.othTentGoods"
                append-icon="mdi-magnify"
                @click:append="getHelpList('othTentGoods')"
                readonly
              ></v-text-field>
            </v-flex>
            <v-flex xs12 v-if="riskSurveyMode === 'Query'">
              <v-subheader class="queryLabel">{{ labels.occpnRemarks }}</v-subheader>
              <div class="queryValue">{{ occpnForm.occpnRemarks }}</div>
            </v-flex>
            <v-flex xs12 v-else>
              <v-textarea
                v-model="occpnForm.occpnRemarks"
                :label="labels.occpnRemarks"
                :error-messages="errors.collect('occpnForm.occpnRemarks')"
                v-validate="'max:1000|entry'"
                data-vv-name="occpnForm.occpnRemarks"
                :data-vv-as="labels.occpnRemarks"
                :counter="1000"
                :rows="8"
              ></v-textarea>
            </v-flex>
          </v-layout>
        </v-container>
      </form>
    </v-card-text>

    <v-dialog v-model="showCargoComdtyHelpList" width="1280px">
      <cargo-comdty-help-list
        :title="dialogTitle"
        @close="showCargoComdtyHelpList = false"
        @assign-cargo-comdty-val-info="assignValue"
      ></cargo-comdty-help-list>
    </v-dialog>

    <v-dialog v-model="showCargoPackHelpList" width="1280px">
      <cargo-pack-help-list @close="showCargoPackHelpList = false" @assign-cargo-pack-val-info="assignValue"></cargo-pack-help-list>
    </v-dialog>
  </v-card>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { formatDisplayDate } from '@/utils/date'
import { occpnClsList, whsTypeList, partTypeList } from './index'
import { expandURI } from '@/utils/ajax'
import CargoComdtyHelpList from '@/components/core/common/dialog/CargoComdtyHelpList'
import CargoPackHelpList from '@/components/core/common/dialog/CargoPackHelpList'

export default {
  data() {
    return {
      labels: {
        occpnCls: 'Occupation Class',
        goodsType: 'Type of Goods',
        packType: 'Type of Packing',
        goodsFlam: 'Flammable Goods',
        storeArr: 'Store Arrangement',
        stacksHgt: 'Height of Stacks',
        whsType: 'Type of Warehouse',
        othTent: 'Any other tenant?',
        part: 'Partition between tenants?',
        partType: 'Type of Partititon',
        othTentGoods: "Other Tenant's Goods",
        occpnRemarks: 'Occupation Comments'
      },
      occpnForm: {
        survNo: undefined,
        verCnt: undefined,
        occpnCls: undefined,
        goodsType: undefined,
        packType: undefined,
        goodsFlam: undefined,
        storeArr: undefined,
        stacksHgt: undefined,
        whsType: undefined,
        othTent: false,
        part: false,
        partType: undefined,
        othTentGoods: undefined,
        occpnRemarks: undefined,
        survDetType: 'occupation'
      },
      occpnQueryForm: {
        goodsType: undefined,
        packType: undefined,
        othTentGoods: undefined
      },
      actionLabel: {
        exit: 'Exit',
        save: 'Save',
        reset: 'Reset'
      },
      validStatus: {
        mandatory: true,
        optional: true
      },
      loading: false,
      showErrorDialog: false,
      submitting: false,
      occpnClsList: [],
      whsTypeList: [],
      partTypeList: [],
      showCargoComdtyHelpList: false,
      showCargoPackHelpList: false,
      fieldParam: undefined,
      dialogTitle: undefined
    }
  },
  watch: {
    displayErrorDialog: {
      handler: function (messages) {
        if (messages && messages.length > 0) {
          this.showErrorDialog = true
        }
      },
      deep: true
    }
  },
  computed: {
    displayErrorDialog() {
      return this.messages
    },
    riskSurveyMenu() {
      return this.$store.state.underwriting.specialFuncUWSettings.riskSurveySettings.menu
    },
    riskSurveyMaster() {
      return this.$store.state.underwriting.specialFuncUWSettings.riskSurveyMaster
    },
    riskSurveyDetails() {
      return this.$store.state.underwriting.specialFuncUWSettings.riskSurveyDetails
    },
    riskSurveyMode() {
      return this.$store.state.underwriting.specialFuncUWSettings.riskSurveyMode
    },
    filterOccpnClsList() {
      return this.occpnClsList.filter((list) => {
        return list.value === parseInt(this.occpnForm.occpnCls)
      })
    },
    filteWhsTyppeList() {
      return this.whsTypeList.filter((list) => {
        return list.value === parseInt(this.occpnForm.whsType)
      })
    },
    filterPartTypeList() {
      return this.partTypeList.filter((list) => {
        return list.value === parseInt(this.occpnForm.partType)
      })
    }
  },
  methods: {
    async doInit() {
      this.occpnForm.survNo = this.riskSurveyMaster.survNo
      this.occpnForm.verCnt = this.riskSurveyMaster.verCnt
      this.loadInit()
    },
    loadInit() {
      this.occpnForm.occpnCls = parseInt(this.riskSurveyDetails.occpnCls)
      this.occpnForm.goodsType = this.riskSurveyDetails.goodsType
      this.occpnForm.packType = this.riskSurveyDetails.packType
      this.occpnForm.goodsFlam = this.riskSurveyDetails.goodsFlam
      this.occpnForm.storeArr = this.riskSurveyDetails.storeArr
      this.occpnForm.stacksHgt = this.riskSurveyDetails.stacksHgt
      this.occpnForm.whsType = parseInt(this.riskSurveyDetails.whsType)
      this.occpnForm.othTent = this.riskSurveyDetails.othTent
      this.occpnForm.part = this.riskSurveyDetails.part
      this.occpnForm.partType = parseInt(this.riskSurveyDetails.partType)
      this.occpnForm.othTentGoods = this.riskSurveyDetails.othTentGoods
      this.occpnForm.occpnRemarks = this.riskSurveyDetails.occpnRemarks

      if (this.riskSurveyMode === 'Query') {
        this.doGetCrgoComdty('goodsType', this.riskSurveyDetails.goodsType)
        this.doGetCrgoComdty('othTentGoods', this.riskSurveyDetails.othTentGoods)
        this.doGetCrgoPack(this.riskSurveyDetails.packType)
      }
    },
    async doGetCrgoComdty(type, data) {
      const apiURI = this.riskSurveyMenu.getCrgoComdty
      if (apiURI) {
        const expand = {
          crgoComdty: data
        }
        this.$http
          .get(expandURI(apiURI, expand))
          .then((result) => {
            const { data } = result.data
            if (data) {
              if (type === 'goodsType') {
                this.occpnQueryForm.goodsType = data
              } else if (type === 'othTentGoods') {
                this.occpnQueryForm.othTentGoods = data
              }
            }
          })
          .catch((err) => {
            const { data } = err.response
            if (data) {
              this.message(data)
              this.fieldMessage(data)
            }
          })
      }
    },
    async doGetCrgoPack(data) {
      const apiURI = this.riskSurveyMenu.getCrgoPack
      if (apiURI) {
        const expand = {
          crgoPack: data
        }
        this.$http
          .get(expandURI(apiURI, expand))
          .then((result) => {
            const { data } = result.data
            if (data) {
              this.occpnQueryForm.packType = data
            }
          })
          .catch((err) => {
            const { data } = err.response
            if (data) {
              this.message(data)
              this.fieldMessage(data)
            }
          })
      }
    },
    getHelpList(field) {
      this.fieldParam = field
      if (field === 'goodsType' || field === 'othTentGoods') {
        this.dialogTitle = 'Type of Goods'
        this.showCargoComdtyHelpList = true
      } else {
        this.showCargoPackHelpList = true
      }
    },
    assignValue(data) {
      if (this.fieldParam === 'goodsType') {
        this.occpnForm.goodsType = data.comdty
      } else if (this.fieldParam === 'othTentGoods') {
        this.occpnForm.othTentGoods = data.comdty
      } else if (this.fieldParam === 'packType') {
        this.occpnForm.packType = data.pack
      }
    },
    formatDate(date) {
      return formatDisplayDate(date)
    },
    doReset() {
      this.occpnForm.occpnCls = undefined
      this.occpnForm.goodsType = undefined
      this.occpnForm.packType = undefined
      this.occpnForm.goodsFlam = undefined
      this.occpnForm.storeArr = undefined
      this.occpnForm.stacksHgt = undefined
      this.occpnForm.whsType = undefined
      this.occpnForm.othTent = false
      this.occpnForm.part = false
      this.occpnForm.partType = undefined
      this.occpnForm.othTentGoods = undefined
      this.occpnForm.occpnRemarks = undefined
    }
  },
  created() {
    this.occpnClsList = occpnClsList
    this.whsTypeList = whsTypeList
    this.partTypeList = partTypeList
  },
  mounted() {
    this.doInit()
  },
  mixins: [MessageMixin],
  components: {
    CargoComdtyHelpList,
    CargoPackHelpList
  }
}
</script>
<style lang="scss">
@import '../../../../../assets/scss/accounting.scss';
</style>
